/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-wink-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM5 8.125h3.75v1.25H5v-1.25zM10 15a5 5 0 01-4.281-2.431l1.068-.625a3.75 3.75 0 006.426 0l1.068.625A5 5 0 0110 15zm2.813-5a1.563 1.563 0 110-3.125 1.563 1.563 0 010 3.125z"/>'
  }
})
